import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type Type = 'version' | 'module' | 'component' | 'service' | 'decorator' | 'helper' | 'pipe' | 'directive';

@Component({
  selector: 'sb-badge, [sb-badge]',
  templateUrl: './sb-badge.component.html',
  styleUrls: ['./sb-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbBadgeComponent {
  @Input()
  public type: Type = 'module';
}
